module.exports = __webpack_public_path__ + "static/media/banner-child-mobile.d4914fa6.png";